/*********************************************************
 * Third Components
*********************************************************/
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
/*********************************************************
 * Components
*********************************************************/
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Select, Button } from 'Components';
import { NotificationManager } from 'Components/Notifications';

/*********************************************************
 * Style
*********************************************************/
import './style.scss';

/*********************************************************
 * Redux
*********************************************************/
import {
  showModalDeleteLandmarkGroups,
  clearRedux,
  deleteLandmarkGroups,
  mapLandmarkGetLandmarkGroups
} from 'Redux/actions';

/*********************************************************
 * Modal to delete landmarks elements
*********************************************************/
const ModalDeleteLandmarkGroup = (props) => {
  const { messages } = props;
  const [landmarkGroup, setLandmarkGroup] = useState();
  const [landmarksGroupsList, setLandmarksGroupsList] = useState([]);

  const dispatch = useDispatch();

  /*********************************************************
   * Get the redux properties
  *********************************************************/
  const {
    smodalLandmarkGroupDelete: open,
    selectedLandmarkGroups: groups,
    landmarkGroups,
    deleteLandmarkGroupsResponse: response,
    loadingDeleteLandmarkGroupsResponse: loading
  } = useSelector((state) => state.realtimeMapLandmarkModuleRedux);

  useEffect(() => {
    if (open && landmarkGroups?.length && groups?.length) {
      let newLandmarkGroups = landmarkGroups.map((item) => {
        return {
          ...item,
          name: `${messages['realtimemaps_landmarks_groups_delete_move']} ${item.name}`
        }
      });

      const groupIds = groups.map(group => {
        return group?.id;
      });

      newLandmarkGroups = newLandmarkGroups.filter(item => !groupIds.includes(item.id));
      setLandmarksGroupsList([...newLandmarkGroups, { id: 0, name: messages['realtimemaps_landmarks_groups_delete'] }]);
      setLandmarkGroup(newLandmarkGroups[0]);
    }
  }, [open, landmarkGroups, groups]);

  useEffect(() => {
    if (open && response) {
      let newState = {};
      if (response?.error) {
        NotificationManager.error(
          messages['errorMessage'],
          messages['error'],
          3000,
          null,
          null,
          'warning',
        );
        newState = {
          deleteLandmarkGroupsResponse: null,
          loadingDeleteLandmarkGroupsResponse: false
        };
      } else {
        NotificationManager.success(
          messages['realtimemaps_landmarks_groups_delete_success'],
          messages['success'],
          3000,
          null,
          null,
          'warning',
        );

        dispatch(mapLandmarkGetLandmarkGroups());
        handleClose();
        newState = {
          landmarkGroups: [],
          deleteLandmarkGroupsResponse: null,
          loadingDeleteLandmarkGroupsResponse: false
        };
      }

      dispatch(clearRedux("MAP_LANDMARKS", newState));
    }
  }, [open, response]);

  const handleClose = () => {
    dispatch(showModalDeleteLandmarkGroups(false));
  }

  return (
    <Modal
      title={messages["realtimemaps_landmarks_groups_delete_modal"]}
      open={open || false}
      handleClose={handleClose}
      loading={loading}
      position="right"
      size="small"
    >
      <ModalBody>
        <div className='modalManageVisibleLandmark'>
          <div>
            <p>{messages['realtimemaps_landmarks_groups_delete_title']}</p>
            <ul>
              {groups.map((group, key) => {
                return (
                  <li key={key}>{group?.name}</li>
                )
              })}
            </ul>
          </div>

          <div style={{ zIndex: 10 }}>
            <Select
              id="landmarkGroup"
              label={messages['realtimemaps_landmarks_groups_delete_action']}
              value={landmarkGroup}
              onChange={(event) => setLandmarkGroup(event)}
              options={landmarksGroupsList}
              textField="name"
              valueField="id"
              placeholder={messages['realtimemaps_landmarks_groups_select_placeholder']}
            />
          </div>

          <div>
            <p>{messages['realtimemaps_landmarks_groups_delete_question']}</p>
            <p>{messages['realtimemaps_landmarks_groups_delete_questionsub']}</p>
          </div>
        </div>
      </ModalBody>

      <ModalFooter>
        <Button
          id={'btn-save-vehicle-group'}
          type="button"
          onClick={(event) => {
            event.preventDefault();
            handleClose();
          }}
          className="btn-gray"
          disabled={loading}
        >
          {messages['realtimemaps_landmarks_groups_delete_cancel']}
        </Button>

        <Button
          id={'btn-save-vehicle-group'}
          type="button"
          onClick={(event) => {
            event.preventDefault();
            dispatch(deleteLandmarkGroups({
              ids: groups?.map(group => {
                return group?.id
              }),
              newId: landmarkGroup?.id
            }));
          }}
          disabled={loading}
          className="btn-red"
        >
          {messages['realtimemaps_landmarks_groups_delete_yes']}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ModalDeleteLandmarkGroup